import { Injectable } from '@angular/core';
import { EmployeeService } from '../employee.service';
import { Observable } from 'rxjs';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { CV_FILE_CONFIG } from 'app/shared/configs/file.config';
import swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class CvManagementService {

  /**
   * Constructor
   *
   * @param {EmployeeService} employeeService
   * 
  */
  constructor(
    private employeeService: EmployeeService
  ) { }

  public getCvByEmployeeId(employeeId: number): Observable<Blob> {
    return this.employeeService.getCvByEmployeeId(employeeId)
  }

  public createFileUploader(): FileUploader {
    return new FileUploader({
      url: '',
      autoUpload: false,
      allowedMimeType: CV_FILE_CONFIG.ALLOWED_FILE_TYPES,
      maxFileSize: CV_FILE_CONFIG.MAX_SIZE
    })
  }

  public invalidFileTypeAlert(): SweetAlertOptions {
    const htmlText = `El tipo del archivo no está permitido.`

    return this.createErrorAlert(htmlText)
  }

  public invalidFileSizeAlert(item: FileLikeObject): SweetAlertOptions {
    const itemSize = this.formatItemSize(item.size)
    const maxSize = this.formatItemSize(CV_FILE_CONFIG.MAX_SIZE)

    const htmlText = `El archivo superó el límite del tamaño permitido. 
    <br> <strong>Tamaño del archivo: </strong> ${itemSize} MB
    <br> <strong>Tamaño permitido: </strong> ${maxSize} MB`

    return this.createErrorAlert(htmlText)
  }

  private formatItemSize(size: number): string {
    return (size / 1024 / 1024).toFixed(2)
  }

  public unknowCvErrorAlert(): SweetAlertOptions {
    const htmlText = `Ha ocurrido un error inesperado al cargar el CV.`

    return this.createErrorAlert(htmlText)
  }

  private createErrorAlert(htmlText: string): SweetAlertOptions {
    return {
      title: '¡Error!',
      html: `${htmlText} <br><br> Póngase en contacto con un administrador.`,
      icon: 'error',
      customClass: {
        confirmButton: 'btn red-bg text-white ml-1'
      },
    }
  }

  public fireSwalAlert(options: SweetAlertOptions): Promise<SweetAlertResult> {
    return swal.fire(options)
  }
}
